import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { PickingRouteAdminFilters } from '../config'
import { DateTime } from 'luxon'

export const deletePickingRoute = (pickingRouteIds: number[]) => {
  const url = new URL(`${ApiConfig.PickingRouteApi}`)

  return axios.delete(url.toString(), {
    data: pickingRouteIds
  })
}

export const getPickingRoutes = (
  page: number,
  pageSize: number,
  filters: PickingRouteAdminFilters
) => {
  const url = new URL(`${ApiConfig.PickingRouteAdminApi}`)

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  const processedFilters = prepareFilters(filters)
  Object.entries(processedFilters).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => url.searchParams.append(key, v))
    } else {
      url.searchParams.set(key, value)
    }
  })

  return axios.get(url.toString())
}

export const prepareFilters = (
  filters: PickingRouteAdminFilters
): Record<string, string | string[]> => {
  const processedFilters: Record<string, string | string[]> = {}

  Object.entries(filters).forEach(([key, value]) => {
    if (value === null || value === '' || value === -1 || value === undefined)
      return

    if (key === 'intialDate') {
      processedFilters[key] = convertStartDateToUTC(value as string) // Inicio del día
    } else if (key === 'endDate') {
      processedFilters[key] = convertEndDateToUTC(value as string) // Final del día
    } else if (key === 'skuId' && Array.isArray(value)) {
      processedFilters[key] = value // Mantén el array tal cual
    } else {
      processedFilters[key] = value.toString()
    }
  })

  return processedFilters
}

// Conversión de fechas
function convertStartDateToUTC(localDate: string): string {
  return DateTime.fromISO(localDate, { zone: 'local' })
    .startOf('day') // Inicio del día (00:00:00)
    .toUTC()
    .toISO()
}

function convertEndDateToUTC(localDate: string): string {
  return DateTime.fromISO(localDate, { zone: 'local' })
    .endOf('day') // Final del día (23:59:59.999)
    .toUTC()
    .toISO()
}

export const getPickingAvailableUsers = (zoneId: number) => {
  const url = new URL(`${ApiConfig.UserApi}/PickersAvailable`)

  url.searchParams.set('zoneId', zoneId.toString())

  return axios.get(url.toString())
}

export const postReassignUserPicker = (
  pickingRouteId: number,
  userId: number
) => {
  const url = new URL(`${ApiConfig.PickingRouteApi}/ChangeRouteUser`)

  return axios.post(url.toString(), { pickingRouteId, userId })
}

export const patchResetPickingRoute = (pickingRouteId: number) => {
  const url = new URL(
    `${ApiConfig.PickingRouteApi}/ResetPickingRoute/${pickingRouteId}`
  )

  return axios.patch(url.toString())
}